import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// import moment from 'moment';
// import PerfectScrollbar from 'react-perfect-scrollbar';
import MultiSelect from '@kenshooui/react-multi-select';
import {
  Box,
  Button,
  Card,
  Grid,
  // FormControl,
  // InputLabel,
  // IconButton,
  // Table,
  // TableBody,
  // TableCell,
  // TableHead,
  // TablePagination,
  // TableRow,
  // TableSortLabel,
  // Select,
  makeStyles
} from '@material-ui/core';
// import {
//   Edit as EditIcon,
//   // Delete as TrashIcon
// } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

// const tableHeaders = [
//   { key: 'username', name: 'Accessname', sort: true },
//   { key: 'email', name: 'Email', sort: true },
//   { key: 'role_name', name: 'Role', sort: true },
//   { key: 'fullname', name: 'Full Name', sort: true },
//   { key: 'created_at', name: 'Created Date', sort: true },
// ];

const Results = ({
  className,
  assigned,
  unAssigned,
  assignedList,
  unAssignedList,
  handleChangeAssigned,
  handleChangeUnAssigned,
  handleAssign,
  handleUnAssign,
  unAssignedSearch,
  handleUnAssignedSearch,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box minWidth={1050}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={5}
            md={5}
            xs={5}
          >
            <MultiSelect
              items={unAssignedList.map((v) => ({
                id: `${v.method}|${v.route}`,
                label: `${v.method} || ${v.route}`,
              }))}
              selectedItems={unAssigned}
              onChange={handleChangeUnAssigned}
              searchValue={unAssignedSearch}
              searchValueChanged={handleUnAssignedSearch}
              showSelectedItems={false}
            />
          </Grid>
          <Grid
            item
            lg={1}
            md={1}
            xs={1}
          >
            <Button
              color="primary"
              size="sm"
              variant="contained"
              onClick={handleAssign}
            >
              {'>>'}
            </Button>
            <Button
              color="danger"
              size="sm"
              variant="contained"
              onClick={handleUnAssign}
            >
              {'<<'}
            </Button>
          </Grid>
          <Grid
            item
            lg={5}
            md={5}
            xs={5}
          >
            <MultiSelect
              items={assignedList.map((v) => ({
                id: `${v.method}|${v.route}`,
                label: `${v.method} || ${v.route}`,
              }))}
              selectedItems={assigned}
              onChange={handleChangeAssigned}
              showSelectedItems={false}
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  assigned: PropTypes.array,
  unAssigned: PropTypes.array,
  assignedList: PropTypes.array,
  unAssignedList: PropTypes.array,
  handleChangeAssigned: PropTypes.func,
  handleChangeUnAssigned: PropTypes.func,
  handleAssign: PropTypes.func,
  handleUnAssign: PropTypes.func,
  unAssignedSearch: PropTypes.string,
  handleUnAssignedSearch: PropTypes.func,
};

export default Results;
